
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Button,
  ButtonGroup,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import { useFilters } from "../context/filters-context";

// ============================================================================
// MAIN GLOBAL FILTERS COMPONENT
// ============================================================================

export const GlobalFilters: React.FC = () => {
  const { filters, setDateRange, setLastNDays, resetFilters } = useFilters();

  // Date handling
  const startDate = dayjs(filters.dateRange.start);
  const endDate = dayjs(filters.dateRange.end);

  const handleStartDateChange = (date: Dayjs | null) => {
    if (date) {
      setDateRange({
        start: date.toISOString(),
        end: filters.dateRange.end,
      });
    }
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date) {
      setDateRange({
        start: filters.dateRange.start,
        end: date.toISOString(),
      });
    }
  };

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        {/* Date Range Section */}
        <Grid size={{ xs: 12, md: "auto" }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <DatePicker
              label="Start"
              value={startDate}
              onChange={handleStartDateChange}
              slotProps={{ textField: { size: "small", sx: { width: 145 } } }}
            />
            <Typography variant="body2" color="text.secondary">
              to
            </Typography>
            <DatePicker
              label="End"
              value={endDate}
              onChange={handleEndDateChange}
              slotProps={{ textField: { size: "small", sx: { width: 145 } } }}
            />
          </Stack>
        </Grid>

        {/* Quick Date Select */}
        <Grid size={{ xs: 12, md: "auto" }}>
          <ButtonGroup size="small" variant="outlined">
            <Button onClick={() => setLastNDays(1)}>1D</Button>
            <Button onClick={() => setLastNDays(7)}>7D</Button>
            <Button onClick={() => setLastNDays(30)}>30D</Button>
            <Button onClick={() => setLastNDays(90)}>90D</Button>
          </ButtonGroup>
        </Grid>

        {/* Reset Button */}
        <Grid size={{ xs: 12, md: "auto" }} sx={{ ml: "auto" }}>
          <Tooltip title="Reset filters">
            <IconButton onClick={resetFilters} size="small">
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </Paper>
  );
};
